import {
  Button,
  CircularProgress,
  FormControl,
  TextField,
} from '@mui/material';
import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import ScreenLoader from '../../../components/Common/ScreenLoader';
import KYCList from './KYCList';
import ReviewKYCDetails from './ReviewKYCDetails';
import { SharedStyledComponents } from '../OnboardingPage';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import { logger } from '../../../utils/logger';
const DynamicComponentRenderer = () => {
  const { stepsInfo } = useOnboarding();
  logger.log('stepsInfo.component', stepsInfo.component);
  if (stepsInfo.component) {
    const LazyComponent = lazy(() => import(`./${stepsInfo.component}`));

    return (
      <Suspense fallback={<ScreenLoader />}>
        {LazyComponent ? <LazyComponent /> : <div>Step not found</div>}
      </Suspense>
    );
  }
};

const KYC = () => {
  const {
    editingMode,
    stepsInfo,
    handleSteps,
    currScreen,
    setCurrScreen,
    setIsBackClick,
    backButtonRef,
    handleNextButton,
    fetchScreenDetails,
    prevPage,
    client,
  } = useOnboarding();

  const { FormWrapper, ContentWrapper, BackButton, ButtonWrapper } =
    SharedStyledComponents;
  const currStepNo = stepsInfo?.order;
  const totalStepNo = stepsInfo?.totalSteps;
  const isLastStep = totalStepNo === currStepNo;

  useEffect(() => {
    backButtonRef.current = () => {
      const newStepNo = stepsInfo.order - 1;
      if (newStepNo === 0) {
        setCurrScreen('landing');
      } else {
        handleSteps(newStepNo);
      }
      setIsBackClick(true);
    };
  }, [stepsInfo, handleSteps]);

  return (
    <Wrapper>
      {currScreen === 'landing' ? (
        <KYCList />
      ) : currScreen === 'review' ? (
        <ContentWrapper>
          <ReviewKYCDetails client={client} />
        </ContentWrapper>
      ) : (
        <FormWrapper>
          {!editingMode && (
            <BackButton
              onClick={() =>
                prevPage === 'kyclist'
                  ? (fetchScreenDetails(), setCurrScreen('landing'))
                  : prevPage === 'component'
                  ? backButtonRef.current()
                  : null
              }
              className="lyt-bck-btn"
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </BackButton>
          )}
          <ContentWrapper>
            {!isLastStep && (
              <div className="progress-wrapper">
                <CircularProgress
                  variant="determinate"
                  value={
                    Math.abs((stepsInfo?.order - 1) / stepsInfo?.totalSteps) *
                    100
                  }
                  size={43}
                  thickness={3}
                  color="primary"
                  progressColor="green"
                  backgroundColor="#ccc"
                />
                <div className="pg">
                  {stepsInfo?.totalSteps - stepsInfo?.order}
                </div>
              </div>
            )}

            <DynamicComponentRenderer
              client={client}
              backButtonRef={backButtonRef}
              handleNextButton={handleNextButton}
            />
          </ContentWrapper>
        </FormWrapper>
      )}{' '}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
`;

// Shared styled components moved to bottom

export default KYC;
